// extracted by mini-css-extract-plugin
export default {"container":"callout-styles_component_container__MTBfu","title":"callout-styles_component_title__OKtNK","body":"callout-styles_component_body__52hif"};